<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="100%"
    content-class="line-relink-dialog-wrapper"
    overlay-class="line-relink-overlay"
  >
    <v-card class="py-5 px-2 relink-card">
      <v-btn
        icon
        small
        class="close-btn"
        @click="closeDialog"
      >
        <v-icon color="white" size="16">mdi-close</v-icon>
      </v-btn>

      <div class="popup-header text-center">
        <h2 class="font-weight-bold"><v-icon color="var(--v-caution-base)" size="28">mdi-alert-circle</v-icon>大切なお知らせ</h2>
      </div>

      <div class="mx-6 my-5">
        <v-divider></v-divider>
      </div>

      <v-card-text class="text-center pa-0">
        <div class="message-text mb-5">
          現在エラーの影響でLINE通知を送ることができません。<br>
          お手数ですが、こちらから友だち登録をお願いいたします。
        </div>
        <div class="mb-3" style="color: #2C2B2B; font-size: 14px;">↓こちらをタップ</div>

        <v-btn
          color="#00c300"
          dark
          block
          rounded
          elevation="2"
          class="line-btn font-weight-bold"
          @click="oAuthTopLine"
        >
          <img src="/assets/img/common/line.svg" alt="LINE" class="mr-2" style="height: 36px; width: auto; vertical-align: middle;">
          友だち追加
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { GET_OAUTH_TOP } from '@/store/line/actions'

export default {
  name: 'LineRelinkPopup',
  data () {
    return {
      dialog: false,
      reshowIntervalHours: 2,
      cookieName: 'line_relink_last_shown',
      c: null
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    }
  },
  watch: {
    '$route' () {
      this.checkVisibility()
    },
    loginUser: {
      handler () {
        this.checkVisibility()
      },
      deep: true
    }
  },
  methods: {
    getQueryStrings () {
      try {
        const search = document.location.search.substring(1)
        const params = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')

        if ('isses' in params) {
          this.c = params.isses
        }
      } catch (e) {
      }
    },
    checkVisibility () {
      if (!this.loginUser || !this.loginUser.user) {
        this.dialog = false
        return
      }

      if (!this.loginUser.user.needs_line_relink) {
        this.dialog = false
        return
      }

      const lastShown = this.getCookie(this.cookieName)
      const now = new Date().getTime()

      if (lastShown) {
        const diffMs = now - parseInt(lastShown, 10)
        const diffHours = diffMs / (1000 * 60 * 60)

        if (diffHours < this.reshowIntervalHours) {
          return
        }
      }

      this.dialog = true
      this.setCookie(this.cookieName, now.toString(), 30)
    },
    closeDialog () {
      this.dialog = false
    },
    oAuthTopLine () {
      this.$store.dispatch(GET_OAUTH_TOP, {
        c: this.c
      })
        .then((data) => {
          location.href = data.url
        })
        .catch((error) => {
          if (error.errorStatus === 400) {
            location.href = error.errorData.url
          }
        })
    },
    setCookie (name, value, days) {
      let expires = ''
      if (days) {
        const date = new Date()
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
        expires = '; expires=' + date.toUTCString()
      }
      document.cookie = name + '=' + (value || '') + expires + '; path=/'
    },
    getCookie (name) {
      const nameEQ = name + '='
      const ca = document.cookie.split(';')
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1, c.length)
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
      }
      return null
    }
  },
  mounted () {
    this.checkVisibility()
    this.getQueryStrings()
  }
}
</script>

<style scoped>
.relink-card {
  position: relative;
  overflow: visible !important;
  border-radius: 12px !important;
}
.close-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: var(--v-caution-base);
  z-index: 20;
  width: 20px !important;
  height: 20px !important;
  min-width: 20px !important;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}
.popup-header h2 {
  color: #2C2B2B;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.message-text {
  color: #2C2B2B;
  font-size: 14px;
  line-height: 24px;
}
.line-btn {
  text-transform: none;
  font-size: 20px;
  height: 60px !important;
  border-radius: 8px !important;
}
</style>

<style>
.line-relink-dialog-wrapper,
.line-relink-dialog-wrapper * {
  overflow: visible !important;
}

.line-relink-dialog-wrapper .v-dialog {
  box-shadow: none !important;
}

.line-relink-dialog-wrapper .v-card.relink-card {
  box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important;
  border-radius: 12px !important;
}
</style>
